import React, { useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface Props {
  /** Путь сервиса на том же origin, напр. /brands или /products-faq */
  path: string;
  title: string;
}

/** Встраивает микрофронт в main без перехода на отдельную страницу. */
const ServiceEmbed: React.FC<Props> = ({ path, title }) => {
  const src = path.endsWith('/') ? path : `${path}/`;
  const [loaded, setLoaded] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: { xs: 'calc(100vh - 140px)', md: 'calc(100vh - 128px)' },
        minHeight: 420,
        borderRadius: 2,
        overflow: 'hidden',
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ px: 2, py: 1, borderBottom: 1, borderColor: 'divider', bgcolor: 'grey.50' }}>
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ flex: 1, position: 'relative' }}>
        {!loaded && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              zIndex: 0,
            }}
          >
            <CircularProgress size={28} />
          </Box>
        )}
        <Box
          component="iframe"
          title={title}
          src={src}
          onLoad={() => setLoaded(true)}
          sx={{
            position: 'relative',
            zIndex: 1,
            width: '100%',
            height: '100%',
            border: 0,
            bgcolor: 'background.paper',
          }}
        />
      </Box>
    </Box>
  );
};

export default ServiceEmbed;
